export default __webpack_public_path__ + "static/media/left-pin.49ff2999.svg";